/**
 * docNoticeBus — app-wide store of Logic Engine documents being rendered.
 *
 * One <GlobalDocumentNotice> (mounted in App) renders the bottom-right
 * progress card for everything in here, so the card shows up on ANY screen
 * and stays visible even while a dialog (e.g. Draft Email) is open.
 *
 * Producers:
 *   • WizardRunner / InformationPage push `create_document` actions the
 *     moment a flow returns them (instant feedback).
 *   • GlobalDocumentNotice polls /api/logic/documents/in-flight so renders
 *     nobody clicked a button for also surface.
 */
let tracked = [];
const dismissed = new Set();
const subscribers = new Set();

const emit = () => { subscribers.forEach((fn) => fn(tracked)); };

export function trackDocuments(docs) {
  const incoming = (docs || []).filter(
    (d) => d && d.document_id && !dismissed.has(d.document_id)
  );
  if (!incoming.length) return;
  const known = new Set(tracked.map((d) => d.document_id));
  const added = incoming
    .filter((d) => !known.has(d.document_id))
    .map((d) => ({
      document_id: d.document_id,
      name:        d.name || d.file_name || "Document",
      status:      d.status || "rendering",
    }));
  if (!added.length) return;
  tracked = [...tracked, ...added];
  emit();
}

// Dismissing hides the card AND remembers the ids, so the in-flight poll
// can't immediately bring the same batch back.
export function dismissDocuments() {
  tracked.forEach((d) => dismissed.add(d.document_id));
  tracked = [];
  emit();
}

export function subscribeDocuments(fn) {
  subscribers.add(fn);
  fn(tracked);
  return () => { subscribers.delete(fn); };
}
